import React from "react";
import "../styles/Disclaimer.css";

const Disclaimer = () => (
  <div className="disclaimer-section">
    <span className="disclaimer-icon">⚠️</span>
    <span className="disclaimer-text">
      We're using the open-source <b>Jamendo API</b> 🎵, which offers
      royalty-free and non-copyrighted music. You might notice some repeated
      tracks 🔄 as this is an experimental project blending AI with mood-based
      music selection 🤖🎶.Oh, and don’t expect the latest musics from Anirudh
      or Santhosh Narayanan here 😂.And to keep things manageable with our
      limited music collection, we've capped song fetches at{" "}
      <b>10 per request</b> 📊. Enjoy the vibes! 😊
    </span>
  </div>
);

export default Disclaimer;
